__turbopack_context__.v({
  "large": "wordmark-module__aPc7fW__large",
  "sd": "wordmark-module__aPc7fW__sd",
  "wordmark": "wordmark-module__aPc7fW__wordmark",
});
